// removed by extract-text-webpack-plugin
module.exports = {"root":"_5oWnq","header":"_1Yx9q","closeIcon":"_2bnxk","title":"_3807o","body":"_3Ousp","createAccount":"_1LclS","signup":"_wz89M"};


//////////////////
// WEBPACK FOOTER
// ./app/components/LoginModal/LoginModal.scss
// module id = 1503
// module chunks = 1